import NavbarLanding from '../components/NavbarLanding'
import HeroSection from '../components/HeroSection'
import FeatureSection from '../components/FeatureSection'
import Workflow from '../components/Workflow'
import Testimonials from '../components/Testimonials'
import { speakingFeature } from '../constants'
import speakingImg from '../assets/speaking.png'
import { themesFeature } from '../constants'
import themesImg from '../assets/themes.png'
import { videosFeature } from '../constants'
import videoImg from '../assets/videos.png'
import { vocabularyFeature } from '../constants'
import vocabularyImg from '../assets/vocabulary.png'
import { wordFeature } from '../constants'
import wordImg from '../assets/word.png'
import { aiChatFeature } from '../constants'
import aiChatImg from '../assets/ai-chat.png'
import { useContext, useEffect } from 'react'
import { AuthContext } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'

const Landing = () => {
    const { currentUser } = useContext(AuthContext)
    const navigate = useNavigate()

    useEffect(() => {
        if (currentUser) {
            navigate('/dashboard')
        }
    }, [currentUser])

    return (
        <div className="from-purple-50 to-white pb-20">
            <NavbarLanding isLanding={true} />
            <div className="max-w-7xl mx-auto pt-10 px-6">
                <HeroSection />
                <FeatureSection />
                <Workflow featuresList={aiChatFeature} side={false} image={aiChatImg} title="Escreva ou fale" subtitle='em inglês com o nossa AI teacher' imageSize='50' />
                <Workflow featuresList={speakingFeature} side={true} image={speakingImg} title="Pratique a fala com" subtitle='feedback em tempo real!' imageSize='50' />
                <Workflow featuresList={themesFeature} side={false} image={themesImg} title="Aprenda com" subtitle='temas específicos' imageSize='50'/>
                <Workflow featuresList={videosFeature} side={true} image={videoImg} title="Veja videos" subtitle='para consolidar o seu conhecimento' imageSize='50'/>
                <Workflow featuresList={vocabularyFeature} side={false} image={vocabularyImg} title="Cresça o seu" subtitle='vocabulário' imageSize='50'/>
                <Workflow featuresList={wordFeature} side={true} image={wordImg} title="Estude cada" subtitle='palavra de uma vez' imageSize='50'/>
                <Testimonials />
                {/* <Footer /> */}
            </div>
        </div>
    )
}

export default Landing
